import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiDownload,
  FiRefreshCw,
  FiDollarSign,
  FiFileText,
  FiCheckCircle,
  FiXCircle,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function InvoicesPayments() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [invoices] = useState([
    {
      id: 1,
      invoiceId: "INV-001",
      userId: "USR-001",
      userName: "Rajesh Kumar",
      amount: 2499,
      tax: 450,
      gst: 450,
      total: 3399,
      status: "Paid",
      paymentDate: "2024-01-15",
      dueDate: "2024-01-20",
      invoiceDate: "2024-01-10",
    },
    {
      id: 2,
      invoiceId: "INV-002",
      userId: "USR-002",
      userName: "Priya Sharma",
      amount: 999,
      tax: 180,
      gst: 180,
      total: 1359,
      status: "Pending",
      paymentDate: null,
      dueDate: "2024-01-25",
      invoiceDate: "2024-01-15",
    },
    {
      id: 3,
      invoiceId: "INV-003",
      userId: "USR-003",
      userName: "Amit Patel",
      amount: 2499,
      tax: 450,
      gst: 450,
      total: 3399,
      status: "Refunded",
      paymentDate: "2024-01-05",
      dueDate: "2024-01-10",
      invoiceDate: "2024-01-01",
    },
  ]);

  const handleProcessRefund = (invoiceId) => {
    Swal.fire({
      title: "Process Refund?",
      text: "This will process a refund for this invoice.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Process Refund",
      confirmButtonColor: "#ef4444",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Refund Processed!", "Refund has been processed successfully.", "success");
      }
    });
  };

  const handleExportGST = () => {
    Swal.fire({
      title: "Export GST Data",
      html: `
        <input id="startDate" class="swal2-input" type="date" placeholder="Start Date" required>
        <input id="endDate" class="swal2-input" type="date" placeholder="End Date" required>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Export",
      confirmButtonColor: "#006e82",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Exporting...", "GST data export initiated.", "info");
      }
    });
  };

  const formatINR = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 0,
    }).format(amount);
  };

  const filteredInvoices = invoices.filter((invoice) => {
    const matchesSearch =
      invoice.invoiceId.includes(searchTerm) ||
      invoice.userName.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = statusFilter === "all" || invoice.status === statusFilter;
    return matchesSearch && matchesStatus;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredInvoices.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredInvoices.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="content-page-header content-page-headersplit">
                <h5>Invoices & Payments</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/billing/invoices-payments">Billing</NavLink> /
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Invoices & Payments
                  </li>
                </ol>
              </nav>
            
          
            </div>

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                <div className="d-flex justify-content-between align-items-center flex-wrap"> {/* Filters */} 
                  <div className="row g-2 flex-grow-1">
                <div className="col-12 col-md-6">
                  <div className="position-relative">
                    <FiSearch
                      style={{
                        position: "absolute",
                        left: "12px",
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#64748b",
                        zIndex: 1,
                      }}
                    />
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search by invoice ID or user name..."
                      value={searchTerm}
                      onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setCurrentPage(0);
                      }}
                      style={{ paddingLeft: "40px" }}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <select
                    className="form-control"
                    value={statusFilter}
                    onChange={(e) => {
                      setStatusFilter(e.target.value);
                      setCurrentPage(0);
                    }}
                  >
                    <option value="all">All Status</option>
                    <option value="Paid">Paid</option>
                    <option value="Pending">Pending</option>
                    <option value="Refunded">Refunded</option>
                  </select>
                </div>
                </div>
                <div className="ms-md-3 mt-3 mt-md-0">
                <button className="btn btn-primary me-2" onClick={handleExportGST}>
                  Export GST
                </button>
                <button className="btn btn-secondary">
                  Export
                </button>
              </div>
              </div>
            </div>

            {/* Invoices Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Invoice ID</th>
                          <th>User</th>
                          <th>Amount</th>
                          <th>Tax</th>
                          <th>GST</th>
                          <th>Total</th>
                          <th>Status</th>
                          <th>Invoice Date</th>
                          <th>Payment Date</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="10">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((invoice) => (
                            <tr key={invoice.id}>
                              <td style={{ fontWeight: "500" }}>{invoice.invoiceId}</td>
                              <td style={{ fontWeight: "500" }}>{invoice.userName}</td>
                              <td style={{ fontWeight: "600" }}>{formatINR(invoice.amount)}</td>
                              <td>{formatINR(invoice.tax)}</td>
                              <td>{formatINR(invoice.gst)}</td>
                              <td style={{ fontWeight: "600" }}>{formatINR(invoice.total)}</td>
                              <td>
                                <span
                                  className={
                                    invoice.status === "Paid"
                                      ? "badge-active"
                                      : invoice.status === "Refunded"
                                      ? "badge-pending"
                                      : "badge-pending"
                                  }
                                >
                                  {invoice.status}
                                </span>
                              </td>
                              <td>{invoice.invoiceDate}</td>
                              <td>{invoice.paymentDate || "-"}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    title="View Invoice"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i className="fas fa-file-alt"></i>
                                  </div>
                                  {invoice.status === "Paid" && (
                                    <div
                                      className="delete-table"
                                      onClick={() => handleProcessRefund(invoice.invoiceId)}
                                      title="Process Refund"
                                      style={{ cursor: "pointer", color: "#ef4444" }}
                                    >
                                      <i className="fas fa-dollar-sign"></i>
                                    </div>
                                  )}
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
